var map = {
	"./issuer.agegroup.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.agegroup.ssi.json",
	"./issuer.omzetbelasting-vp-in-vci.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.omzetbelasting-vp-in-vci.ssi.json",
	"./issuer.omzetbelasting.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.omzetbelasting.ssi.json",
	"./issuer.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.ssi.json",
	"./issuer.woonplaatsverklaring-didebsi.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.woonplaatsverklaring-didebsi.ssi.json",
	"./issuer.woonplaatsverklaring-didweb.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.woonplaatsverklaring-didweb.ssi.json",
	"./issuer.woonplaatsverklaring-vp-in-vci.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/issuer.woonplaatsverklaring-vp-in-vci.ssi.json",
	"./rp.ssi.json": "../../../ssi-demo-configs/oid4vci-demo/rp.ssi.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/configs sync recursive ^\\.\\/.*\\.json$";